export default __webpack_public_path__ + "static/media/330_store05-es-mobile.48e14369.png";